module.exports = __webpack_public_path__ + "static/media/71UfrK9BwbL._AC_SY550._SX._UX._SY._UY_.c2c63934.jpg";